<style scoped>
  #notificationsContent{
    min-width: 300px; 
    max-height: 350px; 
    overflow-y: auto
  }

  #notificationsContent::-webkit-scrollbar {
    width: 8px;
  }

  #notificationsContent::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  #notificationsContent::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
  }

  .notification-item{
    min-width: 400px; 
    position: relative; 
    padding: 6px 20px; 
    padding-top: 22px; 
    border-bottom: 1px solid #c8ced3;
  }

  .notification-item.not-read{
    background: #eee;
  }
  
  .notification-item .btn-link{
    display: block;
    margin-top: -8px;
  }
  
  .notification-item .btn-link:hover{
    text-decoration: underline;
  }
</style>
<template>
  <div>
    <AppHeaderDropdown right no-caret class="mr-3">
      <template slot="header">
        <i class="icon-bell"></i>
        <b-badge v-if="unreadCount" pill variant="danger">
          {{ unreadCount }}
        </b-badge>
      </template>\
      <template slot="dropdown">
        <div id="notificationsContent">
          <b-dropdown-item v-if="fetchingNotifications">
            <Loader :size="40" />
          </b-dropdown-item>

          <b-dropdown-item v-else-if="!notifications">
            <div class="text-center">
              Failed to fetch notifications
            </div>
          </b-dropdown-item>

          <b-dropdown-item v-else-if="!notifications.length">
            <div class="text-center">
              No notifications found
            </div>
          </b-dropdown-item>
          
          <b-dropdown-item v-else-if="hideReadNotifications && !unreadCount">
            <div class="text-center">
              No unread notifications.
            </div>
          </b-dropdown-item>

          <template v-else>
            <template v-for="notification in notifications">
              <div v-if="notification.readAt === null || !hideReadNotifications" :key="notification._id"
                class="notification-item" :class="{'not-read' : !notification.readAt}">
                <div class="mb-1 d-flex w-200">
                  <i class="fa fa-bell-o mr-3" />

                  <div class="flex">
                    <b-button variant="link" class="px-0 pt-0 text-left" @click="handleNotificationClicked(notification)">
                      <h6 class="text-dark" style="margin-bottom: 0; line-height: 1.5em">
                        {{ getTitle(notification) }}
                      </h6>
                    </b-button>

                    <div class="d-flex align-items-center">
                      <small style="margin-top: 0.08em">{{ notification.date }}</small>
                      <button v-if="notification.readAt === null"
                        @click="markNotificationAsRead(notification._id)"
                        class="btn btn-white text-primary px-0 mx-3"
                        :style="{opacity: notification.markingAsRead ? 0.5 : 1}">
                        Mark As Read
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>

        <div style="background: #edf2f4" class="py-1 px-4 d-flex justify-content-end">
          <b-form-checkbox
            v-model="hideReadNotifications"
            :value="true"
            :unchecked-value="false"
          >
            Hide read notifications
          </b-form-checkbox>
        </div>
      </template>
    </AppHeaderDropdown>

    <b-modal title="" :visible="previewedTransaction !== null && !showRejectTransaction"
      @ok="closeTransactionPreview" @cancel="closeTransactionPreview" @hide="closeTransactionPreview">
      <template v-if="previewedTransaction">
        <h4>
          {{ previewedTransaction.title }}
        </h4>
        <template slot="modal-footer">
          <div v-if="previewedTransaction.for === 'transaction-maker'" class="row justify-content-end pb-0">
              &nbsp;
          </div>
          <div v-else-if="previewedTransaction.for === 'transaction-checker'" class="row justify-content-end pb-0">
            <div class="mr-4" v-if="previewedTransaction.approvalStatus === 1">
              Transaction already approved.
            </div>
            <div class="mr-4" v-else-if="previewedTransaction.approvalStatus === 2">
              Transaction already rejected.
            </div>
            <div class="px-3" v-else>
              <button :class="{disabled: approvingTransaction}" class="btn btn-danger px-4 mr-3"
                @click="showRejectTransaction = true">
                REJECT
              </button>
              <button :class="{disabled: approvingTransaction}" class="btn btn-primary px-4"
                @click="approveTransaction">
                {{ !approvingTransaction ? 'APPROVE' : 'Please Wait...' }}
              </button>
            </div>
          </div>
          <div v-else class="row justify-content-end pb-0">
              &nbsp;
          </div>
        </template>
      </template>
    </b-modal>
    
    <form @submit="rejectTransaction($event)">
      <b-modal title="Reject transaction" :visible="showRejectTransaction"
        @ok="closeTransactionPreview" @cancel="closeTransactionPreview" @hide="closeTransactionPreview">
        <div class="form-group mt-3 mb-4">
          <label for="value" class="text-capitalize">Reason for rejection</label>
          <input id="value" class="form-control" v-model="rejectionReason" type="text" required />
        </div>
        <template slot="modal-footer">
          <div class="row justify-content-end pb-0">
            <div class="px-3">
              <button type="submit" :class="{disabled: rejectingTransaction}" class="btn btn-primary px-4">
                {{ !rejectingTransaction ? 'SUBMIT' : 'Please Wait...' }}
              </button>
            </div>
          </div>
        </template>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';

import { mapState } from 'vuex';
import { setTransactionRejected } from '../../../services/API';
import { showSuccessToast, showErrorToast } from '../../../utils';

export default {
  name: 'Notifications',
  data () {
    return {
      previewedTransaction: null,
      approvingTransaction: false,
      showRejectTransaction: false,
      rejectingTransaction: false,
      rejectionReason: "",
      hideReadNotifications: true
    }
  },
  computed: {
    ...mapState(['notifications', 'fetchingNotifications']),
    unreadCount(){
      if(this.notifications)
        return this.notifications.filter(({readAt}) => !readAt).length;

      return 0;
    }
  },
  methods: {
    markNotificationAsRead(id){
      this.$store.dispatch('markNotificationAsRead', id)
    },
    closeTransactionPreview(){
      this.previewedTransaction = null;
    },
    async rejectTransaction(e){
      e.preventDefault();
      try {
        this.rejectingTransaction = true;
        await setTransactionRejected(this.previewedTransaction._id, this.rejectionReason);
        this.rejectionReason = "";
        this.previewedTransaction = null;
        this.rejectingTransaction = false;
        showSuccessToast("Transaction rejected!");
      } catch (error) {
        this.rejectingTransaction = false;
        showErrorToast("Failed to reject transaction!");
      }
    },
    async approveTransaction(){
      this.approvingTransaction = true;
      try {
        this.approvingTransaction = true;
        await setTransactionRejected(this.previewedTransaction._id);
        this.previewedTransaction = null;
        this.approvingTransaction = false;
        showSuccessToast("Transaction approved!");
      } catch (error) {
        this.approvingTransaction = false;
        showErrorToast("Failed to approve transaction!");
      }
    },
    handleNotificationClicked(notification){
      if(!notification.readAt)
        this.markNotificationAsRead(notification._id);

      const { 
        amount, 
        payment, 
        reference, 
        fromExternalAccount, 
        fromExternalAccountType, 
        paidAt,
        approvalStatus
      } = notification.extras;

      const notificationDetails = {
        title: `Approval required for investment of ${parseInt(amount).toLocaleString()} to ${payment.costumer}.`,
        reference, 
        amount, 
        fromExternalAccount, 
        fromExternalAccountType, 
        paidAt,
        approvalStatus,
        for: notification.topic
      }

      if(notification.topic === "transaction-checker"){
        this.previewedTransaction = {
          title: `Approval required for investment of ${parseInt(amount).toLocaleString()} to ${payment.costumer}.`,
          ...notificationDetails
        }
      }
      else if(notification.topic === "transaction-maker"){
        this.previewedTransaction = {
          title: `Investment of ${parseInt(amount).toLocaleString()} to ${payment.costumer} rejected.`,
          ...notificationDetails
        }
      }
    },
    getTitle(notification){
      if(!notification.topic)
        return "";
        
      if(notification.topic === "transaction-checker"){
        const { amount, payment } = notification.extras;
        return `Approval required for investment of ${parseInt(amount).toLocaleString()} to ${payment.costumer}.`;
      }
      else if(notification.topic === "transaction-maker"){
        const { amount, payment } = notification.extras;
        return `Investment of ${parseInt(amount).toLocaleString()} to ${payment.costumer} rejected.`;
      }
    }
  },
  components: {
    AppHeaderDropdown
  }
}
</script>
